import { useAuth } from '../contexts/AuthContext';

/** IMS invoice_permission from verified server user — not sessionStorage. */
export function useInvoicePermission(): string {
  const { user } = useAuth();
  return String(user?.invoice_permission ?? '').trim();
}

export function useIsInvoiceAdmin(): boolean {
  const permission = useInvoicePermission();
  return permission === 'admin' || permission === 'super_admin';
}

/** Wait for auth bootstrap before permission-gated redirects. */
export function useAuthReady(): { loading: boolean; authenticated: boolean } {
  const { user, loading } = useAuth();
  return { loading, authenticated: !!user };
}
